import { render, staticRenderFns } from "./SingleDishMealUser.vue?vue&type=template&id=8bb64bd4&"
import script from "./SingleDishMealUser.vue?vue&type=script&lang=js&"
export * from "./SingleDishMealUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports